import { GetFragmentDto } from '@app/modules/fragments/fragment.types';
import { getFragmentMediaProgressPercent } from '@app/modules/fragments/utils/get-fragment-media-progress-percent';
import { FragmentMediaPlayerSkeleton } from './FragmentMediaPlayerSkeleton';
import { FragmentMediaStalledLoader } from './FragmentMediaStalledLoader';

interface FragmentMediaLoadingProps {
  /** Fragment whose media generation progress to display. */
  fragment: GetFragmentDto;
}

/**
 * Shows the audio or video skeleton with media generation progress while the fragment is processing.
 * When generation is stalled, keeps the normal progress and adds a regenerate chip.
 */
export function FragmentMediaLoading({ fragment }: FragmentMediaLoadingProps) {
  const isVideo = fragment.mediaType === 'VIDEO';
  const mediaProgressPercent = getFragmentMediaProgressPercent(fragment);

  return (
    <FragmentMediaPlayerSkeleton
      aspectRatio={isVideo ? '16 / 9' : '16 / 3'}
      progressPercent={mediaProgressPercent}
      loader={
        fragment.isMediaGenerationStalled ? (
          <FragmentMediaStalledLoader progressPercent={mediaProgressPercent} />
        ) : undefined
      }
    />
  );
}
